
export const environment = {
  production: false,
  API_URL: 'https://murumed.com.ar:8089/'
  //  API_URL: 'http://181.105.122.219:8094/'
};
